import { Identity, } from '@schibsted/account-sdk-browser/es5/identity';
import { decode } from '@finn-no/safe-props';
import ClientActions from './client-actions';
import SchibstedAccountSessionHandler from './schibsted-account-session-handler';
window.addEventListener('load', function () {
    var div = document.getElementById('login-frontend-login-refresh-podlet');
    if (div === null || div === void 0 ? void 0 : div.dataset.props) {
        var dataProps = decode(div.dataset.props);
        var clientActions = new ClientActions(dataProps.trackEndpointUrl, dataProps.hash);
        var handler = new SchibstedAccountSessionHandler(
        // For all properties, see: http://techdocs.spid.no/sdks/javascript/.
        new Identity(dataProps.identity), clientActions);
        handler.refreshSpidSession();
        clientActions.refreshFinnSession();
    }
});
